export class Siniestro {
  listado_siniestros: Array<any> = [];
  siniestro_seleccionado: any = null;
}
